import { render, staticRenderFns } from "./addQuestionnaires.vue?vue&type=template&id=aea13fea&scoped=true&"
import script from "./addQuestionnaires.vue?vue&type=script&lang=js&"
export * from "./addQuestionnaires.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionnaires.vue?vue&type=style&index=0&id=aea13fea&prod&scoped=true&lang=less&"
import style1 from "./addQuestionnaires.vue?vue&type=style&index=1&id=aea13fea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea13fea",
  null
  
)

export default component.exports